export const formatNumber = (
  amount: string | number,
  locales = 'en-us',
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2
) =>
  new Intl.NumberFormat(locales, {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(+amount)
